import { Col, Row } from "react-bootstrap";
import MaterialIcon, { MtIcon } from "../material-icon/material-icon";
import styles from "./steps-icon.module.scss";

export interface ISteps {
  id: number;
  stepIcon: MtIcon;
  stepName: string;
}

interface IProps {
  steps: ISteps[];
  selectedStep: number;
  onStepClick?: (stepNumber: number) => void;
  isDarkMode: boolean;
}

const StepsIcon = (props: IProps) => {
  const { steps, selectedStep, onStepClick, isDarkMode = false } = props;
  return (
    <Row className="g-4">
      {steps.map((step, index) => (
        <Col key={index} className="col-12 col-sm-auto">
          <Row
            className="align-items-center justify-content-center"
            onClick={() => {
              if (onStepClick) {
                onStepClick(step.id);
              }
            }}
          >
            <Col
              className={`${
                selectedStep === step.id ? styles.selected : "px-0"
              } py-2 rounded-2`}
            >
              <Row className="align-items-center">
                <Col className="col-auto pe-0">
                  <MaterialIcon
                    icon={step.stepIcon}
                    size={18}
                    color={
                      selectedStep === step.id
                        ? isDarkMode
                          ? `#ffffff`
                          : `#1A3C84`
                        : isDarkMode
                        ? `#909bad`
                        : `#6F7682`
                    }
                    fill
                  />
                </Col>
                <Col
                  className={`${styles.stepName} col-auto font-size-13 font-weight-500 ps-1`}
                >
                  {step.stepName}
                </Col>
              </Row>
            </Col>
            {index !== steps.length - 1 ? (
              <Col
                className={`${styles.dash} col-auto mx-2 d-none d-sm-block`}
              ></Col>
            ) : (
              ``
            )}
          </Row>
        </Col>
      ))}
    </Row>
  );
};

export default StepsIcon;
